export default __webpack_public_path__ + "images/ss-e4bf9bb42bd5d25190fee9dfdd245c76.svg";